import React, { useContext, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";

import { Link } from "react-router-dom";
import { ThemeContext } from "../../../context/ThemeContext";
import { navtoggle } from "../../../store/actions/AuthActions";

const NavHader = () => {
  const [toggle, setToggle] = useState(false);
  const { navigationHader, openMenuToggle, background } =
    useContext(ThemeContext);
  const dispatch = useDispatch();
  const sideMenu = useSelector((state) => state.sideMenu);
  const handleToogle = () => {
    dispatch(navtoggle());
  };

  const [platform, setPlatform] = useState("desktop"); // desktop | android | ios

  useEffect(() => {
    const userAgent = navigator.userAgent || navigator.vendor || window.opera;

    const isIOS =
      /iPad|iPhone|iPod/.test(userAgent) ||
      (/Mac/.test(userAgent) && navigator.maxTouchPoints > 1);

    if (/android/i.test(userAgent)) {
      setPlatform("android");
    } else if (isIOS) {
      setPlatform("ios");
    } else {
      setPlatform("desktop");
    }
  }, []);

  // console.log("platform ", platform);

  return (
    <div className="nav-header">
      <Link
        to={platform === "desktop" ? "/dashboard" : ""}
        className="brand-logo ps-0 pt-1"
      >
        {/* <svg
          className="logo-abbr"
          width="39"
          height="23"
          viewBox="0 0 39 23"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            className="w3"
            d="M32.0362 22H19.0466L20.7071 18.7372C20.9559 18.2484 21.455 17.9378 22.0034 17.9305L31.1036 17.8093C33.0753 17.6497 33.6571 15.9246 33.7015 15.0821C33.7015 13.2196 32.1916 12.5765 31.4367 12.4878H23.7095L25.9744 8.49673H30.4375C31.8763 8.3903 32.236 7.03332 32.236 6.36814C32.3426 4.93133 30.9482 4.61648 30.2376 4.63865H28.6955C28.2646 4.63865 27.9788 4.19212 28.1592 3.8008L29.7047 0.44798C31.0903 0.394765 32.8577 0.780573 33.5683 0.980129C38.6309 3.42801 37.0988 7.98676 35.6999 9.96014C38.1513 11.9291 38.4976 14.3282 38.3644 15.2816C38.098 20.1774 34.0346 21.8005 32.0362 22Z"
            fill="var(--primary)"
          />
          <path
            className="react-w"
            d="M9.89261 21.4094L0 2.80536H4.86354C5.41354 2.80536 5.91795 3.11106 6.17246 3.59864L12.4032 15.5355C12.6333 15.9762 12.6261 16.5031 12.3842 16.9374L9.89261 21.4094Z"
            fill="white"
          />
          <path
            className="react-w"
            d="M17.5705 21.4094L7.67786 2.80536H12.5372C13.0894 2.80536 13.5954 3.11351 13.8489 3.60412L20.302 16.0939L17.5705 21.4094Z"
            fill="white"
          />
          <path
            className="react-w"
            d="M17.6443 21.4094L28.2751 0H23.4513C22.8806 0 22.361 0.328884 22.1168 0.844686L14.8271 16.2416L17.6443 21.4094Z"
            fill="white"
          />
          <path
            className="react-w"
            d="M9.89261 21.4094L0 2.80536H4.86354C5.41354 2.80536 5.91795 3.11106 6.17246 3.59864L12.4032 15.5355C12.6333 15.9762 12.6261 16.5031 12.3842 16.9374L9.89261 21.4094Z"
            stroke="white"
          />
          <path
            className="react-w"
            d="M17.5705 21.4094L7.67786 2.80536H12.5372C13.0894 2.80536 13.5954 3.11351 13.8489 3.60412L20.302 16.0939L17.5705 21.4094Z"
            stroke="white"
          />
          <path
            className="react-w"
            d="M17.6443 21.4094L28.2751 0H23.4513C22.8806 0 22.361 0.328884 22.1168 0.844686L14.8271 16.2416L17.6443 21.4094Z"
            stroke="white"
          />
        </svg>
        <svg
          className="brand-title"
          width="47"
          height="16"
          viewBox="0 0 47 16"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M8.36 15.2C7.2933 15.2 6.3 15.0267 5.38 14.68C4.4733 14.32 3.68 13.82 3 13.18C2.3333 12.5267 1.8133 11.76 1.44 10.88C1.0667 9.99999 0.880005 9.03999 0.880005 7.99999C0.880005 6.95999 1.0667 5.99999 1.44 5.11999C1.8133 4.23999 2.34 3.47999 3.02 2.83999C3.7 2.18666 4.49331 1.68666 5.40001 1.33999C6.30671 0.979988 7.3 0.799988 8.38 0.799988C9.5267 0.799988 10.5733 0.999988 11.52 1.39999C12.4667 1.78666 13.2667 2.36666 13.92 3.13999L12.24 4.71999C11.7333 4.17332 11.1667 3.76666 10.54 3.49999C9.9133 3.21999 9.2333 3.07999 8.5 3.07999C7.7667 3.07999 7.0933 3.19999 6.48 3.43999C5.88 3.67999 5.35331 4.01999 4.90001 4.45999C4.46001 4.89999 4.1133 5.41999 3.86 6.01999C3.62 6.61999 3.5 7.27999 3.5 7.99999C3.5 8.71999 3.62 9.37999 3.86 9.97999C4.1133 10.58 4.46001 11.1 4.90001 11.54C5.35331 11.98 5.88 12.32 6.48 12.56C7.0933 12.8 7.7667 12.92 8.5 12.92C9.2333 12.92 9.9133 12.7867 10.54 12.52C11.1667 12.24 11.7333 11.82 12.24 11.26L13.92 12.86C13.2667 13.62 12.4667 14.2 11.52 14.6C10.5733 15 9.52 15.2 8.36 15.2ZM16.4113 15V0.999988H22.1713C23.4113 0.999988 24.4713 1.19999 25.3513 1.59999C26.2446 1.99999 26.9313 2.57332 27.4113 3.31999C27.8913 4.06666 28.1313 4.95332 28.1313 5.97999C28.1313 7.00669 27.8913 7.89329 27.4113 8.63999C26.9313 9.37329 26.2446 9.93999 25.3513 10.34C24.4713 10.7267 23.4113 10.92 22.1713 10.92H17.8513L19.0113 9.73999V15H16.4113ZM25.5713 15L22.0313 9.91999H24.8112L28.3713 15H25.5713ZM19.0113 10.02L17.8513 8.77999H22.0513C23.1979 8.77999 24.0579 8.53329 24.6312 8.03999C25.2179 7.54669 25.5113 6.85999 25.5113 5.97999C25.5113 5.08666 25.2179 4.39999 24.6312 3.91999C24.0579 3.43999 23.1979 3.19999 22.0513 3.19999H17.8513L19.0113 1.91999V10.02ZM31.0402 15V0.999988H33.1802L39.3002 11.22H38.1802L44.2002 0.999988H46.3402L46.3602 15H43.9002L43.8802 4.85999H44.4002L39.2802 13.4H38.1202L32.9202 4.85999H33.5202V15H31.0402Z"
            fill="black"
          />
        </svg> */}

        {/* <svg
          className="logo-abbr"
          xmlns="http://www.w3.org/2000/svg"
          width="20"
          height="20"
          viewBox="0 0 20 20"
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        >
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M10.0122 1.82893L11.6874 5.17545C11.8515 5.50399 12.1684 5.73179 12.5359 5.78451L16.2832 6.32391C17.2091 6.45758 17.5775 7.57968 16.9075 8.22262L14.1977 10.8264C13.9314 11.0825 13.8101 11.4505 13.8731 11.812L14.5126 15.488C14.6701 16.3974 13.7023 17.0911 12.8747 16.6609L9.52545 14.9241C9.1971 14.7537 8.80385 14.7537 8.47455 14.9241L5.12525 16.6609C4.29771 17.0911 3.32986 16.3974 3.48831 15.488L4.12686 11.812C4.18986 11.4505 4.06864 11.0825 3.80233 10.8264L1.09254 8.22262C0.422489 7.57968 0.790922 6.45758 1.71678 6.32391L5.4641 5.78451C5.83158 5.73179 6.14942 5.50399 6.31359 5.17545L7.98776 1.82893C8.40201 1.00148 9.59799 1.00148 10.0122 1.82893Z"
            stroke="#888888"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
        <span className="brand-title text-light fs-20">Pragya LIMS</span> */}
        <svg
          xmlns="http://www.w3.org/2000/svg"
          version="1.1"
          width="1500"
          height="40"
          viewBox="0 0 1500 212"
        >
          <g transform="matrix(1,0,0,1,-0.9090909090909918,0.3639303566203864)">
            <svg
              // viewBox="0 0 396 56"
              viewBox="0 0 420 56"
              data-background-color="#ffffff"
              preserveAspectRatio="xMidYMid meet"
              // height="212"
              height="180"
              width="1500"
              xmlns="http://www.w3.org/2000/svg"
            >
              <g
                id="tight-bounds"
                transform="matrix(1,0,0,1,0.2400000000000091,-0.09613254703180019)"
              >
                <svg
                  viewBox="0 0 395.52 56.192265094063615"
                  height="56.192265094063615"
                  width="395.52"
                >
                  <g>
                    <svg
                      viewBox="0 0 460.7980827579752 65.46644422828784"
                      height="56.192265094063615"
                      width="395.52"
                    >
                      <g transform="matrix(1,0,0,1,65.2780827579752,9.047822610421836)">
                        <svg
                          viewBox="0 0 395.52 47.37079900744417"
                          height="47.37079900744417"
                          width="395.52"
                        >
                          <g id="textblocktransform">
                            <svg
                              viewBox="0 0 395.52 47.37079900744417"
                              height="47.37079900744417"
                              width="395.52"
                              id="textblock"
                            >
                              <g>
                                <svg
                                  viewBox="0 0 395.52 47.37079900744417"
                                  height="47.37079900744417"
                                  width="395.52"
                                >
                                  <g transform="matrix(1,0,0,1,0,0)">
                                    <svg
                                      width="395.52"
                                      viewBox="4.5 -35.6 307.23 36.2"
                                      height="47.37079900744417"
                                      data-palette-color="#556970"
                                    >
                                      <g
                                        className="wordmark-text-0"
                                        data-fill-palette-color="primary"
                                        id="text-0"
                                      >
                                        <path
                                          d="M9.25 0L4.5 0 4.5-34.9Q6.55-35.15 9.03-35.27 11.5-35.4 14.15-35.4L14.15-35.4Q18.5-35.4 21.55-34.02 24.6-32.65 26.2-30.25 27.8-27.85 27.8-24.75L27.8-24.75Q27.8-21 25.95-18.4 24.1-15.8 20.8-14.43 17.5-13.05 13.15-13.05L13.15-13.05Q11.05-13.05 9.25-13.2L9.25-13.2 9.25 0ZM13.75-17L13.75-17Q18.2-17 20.65-19 23.1-21 23.1-24.35L23.1-24.35Q23.1-27.6 20.75-29.5 18.4-31.4 14.05-31.4L14.05-31.4Q12.7-31.4 11.5-31.35 10.3-31.3 9.25-31.2L9.25-31.2 9.25-17.25Q10.05-17.15 11.2-17.07 12.35-17 13.75-17ZM58.4-1.5L53.95 0.6 49.6-8.9Q47.95-12.45 45.45-13.95 42.95-15.45 39.05-15.45L39.05-15.45 38.3-15.45 38.3 0 33.55 0 33.55-34.9Q36.2-35.15 38.62-35.27 41.05-35.4 43.8-35.4L43.8-35.4Q50.2-35.4 53.42-32.8 56.65-30.2 56.65-26.1L56.65-26.1Q56.65-22.45 54.47-20.23 52.3-18 48.2-16.9L48.2-16.9Q49.55-16.3 50.6-15.48 51.65-14.65 52.62-13.28 53.6-11.9 54.6-9.7L54.6-9.7 58.4-1.5ZM38.3-31.2L38.3-19.45 43.8-19.45Q47.4-19.45 49.65-21.05 51.9-22.65 51.9-25.65L51.9-25.65Q51.9-28.15 49.8-29.78 47.7-31.4 43.8-31.4L43.8-31.4Q42.1-31.4 40.75-31.35 39.4-31.3 38.3-31.2L38.3-31.2ZM92.8-1.25L88.45 0.5 84.55-9.5 68.34-9.5 64.45 0.4 60.4-1.25 74.09-35 79.3-35 92.8-1.25ZM76.45-30.3L69.84-13.5 83-13.5 76.45-30.3ZM109.74 0.6L109.74 0.6Q105.69 0.6 102.54-1.5 99.39-3.6 97.59-7.48 95.79-11.35 95.79-16.6L95.79-16.6Q95.79-22.2 97.69-26.48 99.59-30.75 103.17-33.18 106.74-35.6 111.79-35.6L111.79-35.6Q115.04-35.6 117.59-34.8 120.14-34 122.39-32.75L122.39-32.75 120.64-28.8Q118.54-29.95 116.37-30.7 114.19-31.45 111.54-31.45L111.54-31.45Q108.39-31.45 105.94-29.78 103.49-28.1 102.07-24.85 100.64-21.6 100.64-16.9L100.64-16.9Q100.64-12.7 101.94-9.73 103.24-6.75 105.54-5.15 107.84-3.55 110.84-3.55L110.84-3.55Q113.64-3.55 115.82-4.73 117.99-5.9 119.24-7.15L119.24-7.15 119.24-14.8 111.99-14.8 111.99-18.55 123.74-18.55 123.74 0 119.54 0 119.54-3.5Q117.79-1.95 115.29-0.68 112.79 0.6 109.74 0.6ZM144.39 0L139.64 0 139.64-13.3 127.49-33.05 131.49-35.45 142.19-17.7 152.69-35.25 156.44-33.05 144.39-13.3 144.39 0ZM189.84-1.25L185.49 0.5 181.59-9.5 165.39-9.5 161.49 0.4 157.44-1.25 171.14-35 176.34-35 189.84-1.25ZM173.49-30.3L166.89-13.5 180.04-13.5 173.49-30.3Z"
                                          // fill="#556970"
                                          fill="#ffffff"
                                          data-fill-palette-color="primary"
                                        ></path>
                                        <path
                                          d="M230.14 0L209.34 0 209.34-35 214.09-35 214.09-4.25 230.14-4.25 230.14 0ZM239.64 0L234.89 0 234.89-35 239.64-35 239.64 0ZM253.13 0L248.63 0 248.63-35 255.28-35 264.98-12.85 274.53-35 281.33-35 281.33 0 276.58 0 276.58-28.95 267.23-7.9 262.53-7.9 253.13-28.95 253.13 0ZM299.03 0.6L299.03 0.6Q295.38 0.6 292.38-0.38 289.38-1.35 287.33-2.95L287.33-2.95 289.73-6.95Q291.53-5.45 293.78-4.5 296.03-3.55 299.03-3.55L299.03-3.55Q302.63-3.55 304.73-5.05 306.83-6.55 306.83-9.1L306.83-9.1Q306.83-10.55 306.23-11.68 305.63-12.8 303.91-13.88 302.18-14.95 298.83-16.2L298.83-16.2Q295.23-17.6 293.08-19.03 290.93-20.45 290.01-22.28 289.08-24.1 289.08-26.6L289.08-26.6Q289.08-29.1 290.46-31.13 291.83-33.15 294.51-34.38 297.18-35.6 300.98-35.6L300.98-35.6Q304.08-35.6 306.56-34.98 309.03-34.35 311.38-33.2L311.38-33.2 309.63-29.15Q307.93-30.15 305.66-30.83 303.38-31.5 300.88-31.5L300.88-31.5Q297.58-31.5 295.68-30.2 293.78-28.9 293.78-26.85L293.78-26.85Q293.78-25.55 294.33-24.55 294.88-23.55 296.51-22.6 298.13-21.65 301.38-20.45L301.38-20.45Q305.28-19 307.56-17.4 309.83-15.8 310.78-13.93 311.73-12.05 311.73-9.65L311.73-9.65Q311.73-6.4 310.11-4.1 308.48-1.8 305.61-0.6 302.73 0.6 299.03 0.6Z"
                                          // fill="#b19dd0"
                                          fill="#30bbaa"
                                          data-fill-palette-color="secondary"
                                        ></path>
                                      </g>
                                    </svg>
                                  </g>
                                </svg>
                              </g>
                            </svg>
                          </g>
                        </svg>
                      </g>
                      <g>
                        <svg
                          viewBox="0 0 54.094974011493804 65.46644422828784"
                          height="65.46644422828784"
                          width="54.094974011493804"
                        >
                          <g>
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              version="1.1"
                              x="0"
                              y="0"
                              viewBox="44.467 0 423.06600000000003 512"
                              enableBackground="new 0 0 512 512"
                              height="65.46644422828784"
                              width="54.094974011493804"
                              className="icon-icon-0"
                              data-fill-palette-color="accent"
                              id="icon-0"
                            >
                              <g
                                fill="#556970"
                                data-fill-palette-color="accent"
                              >
                                <path
                                  d="M256 0C139.167 0 44.467 94.708 44.467 211.533 44.467 372.184 256 512 256 512s211.533-139.816 211.533-300.467C467.533 94.708 372.833 0 256 0zM256 375.941c-90.8 0-164.4-73.6-164.4-164.408 0-90.8 73.601-164.408 164.4-164.408s164.417 73.608 164.417 164.408C420.417 302.342 346.8 375.941 256 375.941z"
                                  // fill="#556970"
                                  fill="#ffffff"
                                  data-fill-palette-color="accent"
                                ></path>
                                <path
                                  d="M277.358 188.417v-58.884c5.425 0 9.816-4.4 9.816-9.816 0-5.417-4.392-9.817-9.816-9.817h-47.242c-5.425 0-9.816 4.4-9.816 9.817 0 5.417 4.392 9.816 9.816 9.816v58.884l-53.975 78.5c-3.083 4.1-4.908 9.2-4.908 14.716 0 13.551 10.983 24.534 24.533 24.534h115.941c13.551 0 24.533-10.983 24.533-24.534 0-5.516-1.824-10.616-4.908-14.716L277.358 188.417z"
                                  // fill="#556970"
                                  fill="#ffffff"
                                  data-fill-palette-color="accent"
                                ></path>
                              </g>
                            </svg>
                          </g>
                        </svg>
                      </g>
                    </svg>
                  </g>
                  <defs></defs>
                </svg>
                <rect
                  width="395.52"
                  height="56.192265094063615"
                  fill="none"
                  stroke="none"
                  visibility="hidden"
                ></rect>
              </g>
            </svg>
          </g>
        </svg>
      </Link>

      {platform === "desktop" && (
        <div
          className="nav-control"
          onClick={() => {
            handleToogle();
          }}
        >
          <div className={`hamburger ${sideMenu ? "is-active" : ""}`}>
            <span className="line"></span>
            <span className="line"></span>
            <span className="line"></span>
          </div>
        </div>
      )}
    </div>
  );
};

export default NavHader;
